import { ClientOrganizerSection } from '@st/sdk'
import { Button, Dialog, DialogButtons } from '@st/theme'
import { useState } from 'react'
import { useSDK } from '~/features/app-deps-provider'
import { useOrganization } from '~/features/organizations/organization-provider'
import { useProcess } from '~/store'
import { platformModule } from '~/features/st-pdf-viewer/platform-module'
import { inflect } from '@st/util/inflect'

export function STToggleClientOrganizerSectionsDialog({
  action,
  onClose
}: {
  action: {
    type: 'enableClientOrganizerSection' | 'disableClientOrganizerSection'
    section: ClientOrganizerSection
    folderIds: string[]
  }
  onClose: () => void
}) {
  const sdk = useSDK()
  const organization = useOrganization()
  const platform = useProcess(platformModule)

  const [status, setStatus] = useState<'idle' | 'submitting'>('idle')

  async function onSubmit() {
    setStatus('submitting')

    if (action.type === 'enableClientOrganizerSection') {
      await sdk.send({
        type: 'folders/bulkEnableClientOrganizerSections',
        folderIds: action.folderIds,
        organizationId: organization.id,
        section: action.section
      })
    } else {
      await sdk.send({
        type: 'folders/bulkDisableClientOrganizerSections',
        folderIds: action.folderIds,
        organizationId: organization.id,
        section: action.section
      })
    }

    setStatus('idle')

    platform.send({
      type: 'showSnackbar',
      message: `Questionnaires ${
        action.type === 'enableClientOrganizerSection' ? 'enabled' : 'disabled'
      } for ${action.folderIds.length} ${inflect(action.folderIds.length, 'client organizer')}`
    })

    onClose()
  }

  switch (action.type) {
    case 'enableClientOrganizerSection':
      return (
        <Dialog
          title="Enable questionnaires"
          subtitle="You can optionally enable a questionnaire for the organizers of the selected clients"
          buttons={
            <DialogButtons>
              <Button variant="default" onClick={onClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onSubmit} disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Enabling Questionnaires...' : 'Enable Questionnaires'}
              </Button>
            </DialogButtons>
          }
        ></Dialog>
      )
    case 'disableClientOrganizerSection':
      return (
        <Dialog
          title="Disable questionnaires"
          subtitle="You can disable the questionnaire for the organizers of the selected clients. Once you do this, the organizer will only contain a document request list and a way to upload documents."
          buttons={
            <DialogButtons>
              <Button variant="default" onClick={onClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onSubmit} disabled={status === 'submitting'}>
                {status === 'submitting' ? 'Disabling Questionnaires...' : 'Disable Questionnaires'}
              </Button>
            </DialogButtons>
          }
        ></Dialog>
      )
  }
}
